import IpcRouter from '@shared/ipc/IpcRouter'
import { AudioNote, GoogleMeetMeeting, DetectedMeeting, RecallDetectedMeeting, CalendarEvent } from '@highlight/common'
import { AudioDebugInfo } from '@shared/types/audio-debug-info'

export type AudioNoteIpcResult = AudioNote & { uri: string }

export interface AudioNoteIpcRouterType {
  getAudioNotesWithinTimeWindowDays(timeWindow: number): Promise<AudioNoteIpcResult[]>
  getAudioNotes(): Promise<AudioNoteIpcResult[]>
  getAudioNote(id: string): Promise<AudioNoteIpcResult | undefined>
  updateAudioNote(options: {
    id: string
    updates: Partial<Omit<AudioNote, 'id'>>
  }): Promise<AudioNoteIpcResult | undefined>
  deleteAudioNote(id: string): Promise<void>
  /** Resolves true when a session is running or on its way, false once main gave up on this start. */
  startRecording(meeting?: DetectedMeeting | GoogleMeetMeeting | RecallDetectedMeeting): Promise<boolean>
  stopRecording(save?: boolean): Promise<void>
  pauseRecording(): Promise<void>
  resumeRecording(): Promise<void>
  clearAudioNoteState(): Promise<void>
  clearDetectedMeeting(): Promise<void>
  startAwaitingMeetingJoin(meeting: CalendarEvent): Promise<void>
  cancelAwaitingMeetingJoin(): Promise<void>
  generateSummaryForSavedNote(): Promise<void>
  getAudioDebugInfo(): Promise<AudioDebugInfo>
  applyAudioSessionSpeakerRename(payload: {
    audioSessionId: string
    dgSpeakerIndex: string
    name: string | null
  }): Promise<void>
}

class AudioNoteIpcRouter extends IpcRouter<AudioNoteIpcRouterType> {
  constructor() {
    super('audio-note', {
      getAudioNotesWithinTimeWindowDays: true,
      getAudioNotes: true,
      getAudioNote: true,
      updateAudioNote: true,
      deleteAudioNote: true,
      startRecording: true,
      stopRecording: true,
      pauseRecording: true,
      resumeRecording: true,
      clearAudioNoteState: true,
      clearDetectedMeeting: true,
      startAwaitingMeetingJoin: true,
      cancelAwaitingMeetingJoin: true,
      generateSummaryForSavedNote: true,
      getAudioDebugInfo: true,
      applyAudioSessionSpeakerRename: true,
    })
  }
}

export default AudioNoteIpcRouter
